/* eslint-disable no-restricted-globals */

const safeStorageFactory = (getStorage: () => Storage) => {
  return {
    getItem: (key: string) => {
      if (process.env.STORYBOOK) {
        return null;
      }
      try {
        return getStorage().getItem(key);
      } catch (e) {
        console.error(`getItem failed for key ${key}`, e);
        return null;
      }
    },
    setItem: (key: string, value: string) => {
      if (process.env.STORYBOOK) {
        return;
      }
      try {
        getStorage().setItem(key, value);
        return true;
      } catch (e) {
        console.error(`setItem failed for key ${key} and value ${value}`, e);
        return false;
      }
    },
  };
};

export const safeLocalStorage = safeStorageFactory(() => localStorage);

export const safeSessionStorage = safeStorageFactory(() => sessionStorage);
